var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-box flex-col flex-center"},[_c('img',{staticClass:"icon-lose",attrs:{"src":require("../../assets/images/icon-lose.svg")}}),_c('div',{staticClass:"error-msg"},[_vm._v("链接已丢失，请检查网址是否输入正确")])])
}]

export { render, staticRenderFns }